import React, { useState } from "react";
import FullWidthTextField from "../../../components/TextField/FullWidthTextField";
import { editiconorange } from "../../../images";
import TextFieldWithIcon from "../../../components/TextFieldWithIcon/TextFieldWithIcon";
import Joi from "joi";
import http from "../../../helpers/http";
import { useAuth } from "../../../context/Auth/AuthState";
import config from "../../../config/config";
import { toast } from "react-toastify";
import ToastMsg from "../../../components/ToastMsg/ToastMsg";
import useTheme from "../../../components/useTheme/useTheme";

const EditBusinessUserName = ({ lightTheme }) => {
  // =============== VARIABLE & STATES  ===========================
  const { theme } = useTheme();
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [values, setValues] = useState({
    username: "",
  });
  const [formError, setFormError] = useState({});

  const auth = useAuth();

  const joiOptions = config.joiOptions;

  const base_url = config.api_url; //without trailing slash

  // =============== FUNCTIONS  ===========================

  const handleChange = (e) => {
    setValues((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const validate = async (data) => {
    let schemaObj = {
      username: Joi.string().trim().required().label("Name"),
    };

    const schema = Joi.object(schemaObj).options({ allowUnknown: true });

    const { error } = schema.validate(data, joiOptions);

    const errors = {};

    if (error) {
      error.details.map((field) => {
        errors[field.path[0]] = field.message;
        return true;
      });
    }

    return errors ? errors : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (values.username.trim() === auth?.user?.username?.trim()) {
      setFormError({
        username: "New username cannot be same as current username",
      });
      return;
    }

    let errors = await validate(values);

    setFormError(errors);
    if (Object.keys(errors).length) {
      return;
    }

    const data = await http.put(
      base_url + "/business/update-username/" + auth?.user?._id,
      values
    );
    if (data) {
      const updatedUserData = await http.get(
        base_url + "/business/edit-profile/" + auth?.user?._id
      );

      if (updatedUserData) {
        auth.refresh(updatedUserData?.data?.data);
        localStorage.setItem(config.jwt_auth_key, updatedUserData?.data?.token);
        toast(
          <ToastMsg message="Your detail is updated" />,
          config.success_toast_config
        );
        setValues({});
        setIsEditClicked(false);
      }
    }
  };
  // =============== HTML RENDERING  ===========================
  // =============== DATA FETCHING  ===========================
  // =============== SIDE EFFECTS  ===========================

  return (
    <>
      <div
        className="field_wrapper padding_right disabled_field"
        onClick={() => {
          setIsEditClicked((prevCheck) => !prevCheck);
        }}
      >
        <TextFieldWithIcon
          icon={editiconorange}
          label="Edit Business Username"
          disabled={isEditClicked}
          value={auth?.user?.username || ""}
          lightTheme={lightTheme}
          // value={"hello"}
          // InputProps={{
          //   readOnly: true,
          // }}
        />
      </div>
      {isEditClicked && (
        <>
          <form onSubmit={handleSubmit}>
            <div className="field_wrapper padding_right">
              <FullWidthTextField
                label="Your New Business Username*"
                name="username"
                value={values.username}
                onChange={handleChange}
                lightTheme={lightTheme}
              />
              {formError.username && (
                <p className="error">{formError.username}</p>
              )}
            </div>
            <div className="mobile_center">
              <div className="btn_wrapper">
                <button className="submit_button">Submit</button>
                <button
                  type="button"
                  className={`back_button ${theme === "dark" && "text-white"}`}
                  onClick={() => setIsEditClicked(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </>
      )}
    </>
  );
};

export default EditBusinessUserName;
